<script lang="ts">
    import { getDBEntries } from "../../api"
    import { spaLink } from "../actions"
    import { navigationCache } from "../store"
    import CrinkledSection from "./CrinkledSection.svelte"
    enum NavigationType {
        MainNavigation = 0,
        ServiceNavigation = 1,
        LegalNavigation = 2,
    }
    let navigationEntries: NavigationEntry[] = [],
        windowWidth: number

    function elementsToCache(elements: NavigationElement[]) {
        elements.forEach((el) => {
            if (!el.external) {
                if (!$navigationCache[el.page]) $navigationCache[el.page] = el
                if (el.elements?.length > 0) elementsToCache(el.elements)
            }
        })
    }

    getDBEntries("navigation").then((navs) => {
        navigationEntries = navs.sort((a, b) => a.type - b.type)
        navigationEntries.forEach((nav) => elementsToCache(nav.elements))
    })

    $: isMobile = windowWidth < 1024
    export let className = ""
    let sections: {
        title: string
        links: NavigationElement[]
    }[] = []
    $: if (navigationEntries.length)
        sections = [
            {
                title: "Service",
                links: navigationEntries[NavigationType.ServiceNavigation].elements,
            },
            {
                title: "BKDF",
                links: navigationEntries[NavigationType.MainNavigation].elements,
            },
        ]

    const paymentsIcons = ["klarna", "mastercard", "paypal", "visa", "applepay", "americanexpress"]
    const socialIcons = { facebook: "", instagram: "", tiktok: "", youtube: "" }
</script>

<CrinkledSection>
    <footer class="{'footer ' + className}">
        <section id="content-section">
            <section id="content-link-section">
                {#each sections as section}
                    <section class="content">
                        <div class="row">
                            <div class="col">
                                <small class="service"><em>{section.title}</em></small>
                                <nav class="sub-points">
                                    <ul>
                                        {#each section.links as link}
                                            <li>
                                                <a
                                                    class="footer-nav-point"
                                                    use:spaLink
                                                    href="{link.page}"><small>{link.name}</small></a
                                                >
                                            </li>
                                        {/each}
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    </section>
                {/each}
            </section>
            <section id="newsletter-section"></section>
        </section>
        <section id="icons-section">
            <section class="payments">
                {#each paymentsIcons as icon}
                    <figure class="footer-icon">
                        <img
                            alt="Payment Icon"
                            class="icon"
                            src="../../../media/{icon}.svg"
                        />
                    </figure>
                {/each}
            </section>
            <div class="line">
                <div class="line-1"></div>
                <img
                    alt="Symbol"
                    class="symbol"
                    src="../../../logo/logoShort.svg"
                />
                <div class="line-2"></div>
            </div>
            <ul class="social">
                {#each Object.keys(socialIcons) as icon}
                    <li>
                        <a
                            href="{socialIcons[icon]}"
                            use:spaLink
                            target="_blank"
                        >
                            <figure class="footer-icon">
                                <img
                                    alt="{icon}"
                                    src="../../../media/{icon}.svg"
                                />
                            </figure></a
                        >
                    </li>
                {/each}
            </ul>
        </section>
        <section id="legal-section">
            <div class="wrapper">
                <small class="">© 2024 | BKDF - Bin Krass Du Fass | Alle Rechte vorbehalten.</small>
                <nav class="nav-points">
                    <ul>
                        {#each navigationEntries.length ? navigationEntries[NavigationType.LegalNavigation].elements : [] as link}
                            <li>
                                <a
                                    class="footer-nav-point-bottom"
                                    use:spaLink
                                    href="{link.page}"><small>{link.name}</small></a
                                >
                            </li>
                        {/each}
                    </ul>
                </nav>
            </div>
        </section>
    </footer>
</CrinkledSection>

<style lang="less">
    @import "../../lib/assets/css/variables.less";
    .footer {
        &,
        & * {
            box-sizing: border-box;
        }
        background: var(--neutral-white);
        justify-self: flex-end;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        position: relative;
        width: 100%;
        gap: 1.5rem;
        #content-section {
            margin: 0px var(--horizontal-default-margin);
            max-width: var(--small-max-width);
            width: 100%;
            display: flex;
            flex-direction: row;
            gap: 1.5rem;
            align-items: flex-start;
            justify-content: flex-start;
            position: relative;
            #content-link-section {
                display: flex;
                flex-direction: row;
                gap: 1.5rem;
                align-items: flex-start;
                justify-content: flex-start;
                flex: 1;
                position: relative;
                .content {
                    display: flex;
                    flex-direction: column;
                    gap: 1.125rem;
                    align-items: flex-start;
                    justify-content: flex-start;
                    width: 12.25rem;
                    position: relative;
                }
            }
        }

        #icons-section {
            margin: 0px var(--horizontal-default-margin);
            max-width: var(--small-max-width);
            width: 100%;
            margin: 0 0 0 -0.0625rem;
            display: flex;
            gap: 0.625rem;
            align-items: flex-start;
            justify-content: flex-start;
            flex: 1;
            position: relative;
            overflow: hidden;
            .payments,
            .social {
                display: flex;
                gap: 0.75rem;
            }
            .line {
                padding: 0rem 1.5rem 0rem 1.5rem;
                display: flex;
                flex-direction: row;
                gap: 1.5rem;
                align-items: center;
                justify-content: flex-start;
                flex: 1;
                position: relative;
                overflow: hidden;
                .line-1,
                .line-2 {
                    border-style: solid;
                    border-color: var(--text-invers-100);
                    border-width: 0.0625rem 0 0 0;
                    flex: 1;
                    height: 0rem;
                    position: relative;
                }
            }
        }

        #legal-section {
            display: flex;
            justify-content: center;
            width: 100%;
            background: var(--bg-100);
            .wrapper {
                max-width: var(--small-max-width);
                width: 100%;
                a,
                small {
                    color: var(--text-100);
                }

                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: space-between;
                flex-shrink: 0;
                position: relative;
                padding: 1.5rem 0px;
                margin: 0px var(--horizontal-default-margin);

                .nav-points {
                    display: flex;
                    flex-direction: row;
                    gap: 1.5rem;
                    align-items: center;
                    justify-content: flex-start;
                    position: relative;
                }
            }
        }
    }
</style>
